/**
 * Idiomas da interface.
 *
 * Mora no shared, e não no web, porque o servidor precisa validar o que grava
 * na coluna `user.idioma` — a lista tem de ser uma só. O texto traduzido em si
 * não passa por aqui: catálogo é coisa do front (`apps/web/src/i18n`), e o
 * servidor continua falando português.
 *
 * A variante importa. `es-CL` não é enfeite: muda formato de data (dd-mm-aaaa),
 * e separador de milhar, que o `Intl` resolve sozinho a partir da etiqueta.
 */
export const IDIOMAS = ['pt-BR', 'es-CL'] as const

export type Idioma = (typeof IDIOMAS)[number]

export const IDIOMA_PADRAO: Idioma = 'pt-BR'

export function ehIdioma(valor: unknown): valor is Idioma {
  return typeof valor === 'string' && (IDIOMAS as readonly string[]).includes(valor)
}

/**
 * Etiqueta de idioma → idioma do app.
 *
 * Compara só o primeiro trecho: o navegador de um chileno manda `es-CL`, o de
 * um argentino `es-AR`, e o de quem configurou o sistema em espanhol genérico
 * manda `es`. Os três caem no mesmo lugar — é espanhol o que temos para
 * oferecer, e uma variante diferente é melhor do que português.
 */
export function idiomaDaEtiqueta(etiqueta: string | null | undefined): Idioma | null {
  const base = etiqueta?.toLowerCase().split('-')[0]
  if (base === 'es') return 'es-CL'
  if (base === 'pt') return 'pt-BR'
  return null
}
